import { render, staticRenderFns } from "./UserCoupon.vue?vue&type=template&id=7979718d&scoped=true"
import script from "./UserCoupon.vue?vue&type=script&lang=js"
export * from "./UserCoupon.vue?vue&type=script&lang=js"
import style0 from "./UserCoupon.vue?vue&type=style&index=0&id=7979718d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7979718d",
  null
  
)

export default component.exports